import React from "react";
import Questionmark from './Questionmark';
import { Slider, SliderMarker, SliderTrack, SliderTrackHighlight, SliderHandle } from "@reach/slider";
import "@reach/slider/styles.css";

export default function(props) {
  return (
    <>
      <p class="slider__questionmark"> 
        <Questionmark value = {props.questionmarkValue}/> 
        <label>{props.label}</label>
      </p>

      <div style={{ display: 'flex', alignItems: 'center' }}>

        <input type="range" min={0} max={100}

          value={props.value}
          onChange={event => props.onChange(event.target.value)}

        />

        <span className="slider-result"> {props.value} % </span>
      </div>
    </>
  )
}


